import SponsorsSec from "./SponsorsSec";

export default SponsorsSec;
